import type { ReactNode } from 'react'
import { useUi } from '../../state/ui'

/** A bot's name or icon that opens its profile. */
export function BotProfileButton({ userId, label, className, children, hidden = false }: { userId: string; label: string; className?: string; children: ReactNode; hidden?: boolean }) {
  const open = useUi((s) => s.openBotProfile)
  return (
    <button
      type="button"
      className={className ? `bot-profile-button ${className}` : 'bot-profile-button'}
      aria-label={hidden ? undefined : label}
      aria-hidden={hidden ? true : undefined}
      tabIndex={hidden ? -1 : undefined}
      onClick={() => open(userId)}
    >
      {children}
    </button>
  )
}
